/**
 * G12. Собрать месяц: 6 статей, вычеркнуть 2; сумма и последствие
 * написаны на каждой. Что вычеркнул — то и будет.
 */
import { t } from '@life/i18n';
import type { BudgetInput, BudgetState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Pick } from './ui/Pick';

export function Budget({ state, onInput }: MinigameScreenProps<BudgetInput, BudgetState>) {
  const [picks, setPicks] = useState<number[]>([]);
  return (
    <>
      <p class="hint">{t('ui.minigame.budget.rules', { sum: money(state.monthly), n: state.cuts })}</p>
      <Pick
        label={t('ui.minigame.budget.label')}
        items={state.items.map((it) => ({ text: t(it.key), note: `${money(it.amount)} · ${t(it.effectKey)}` }))}
        max={state.cuts}
        value={picks}
        onChange={setPicks}
      />
      <button type="button" class="btn accent block" disabled={picks.length < state.cuts} onClick={() => onInput({ picks })}>
        {t('ui.minigame.budget.submit')}
      </button>
    </>
  );
}
